const KEY = 'myaudience.referral.v1';
const TOKEN = /^[A-Za-z0-9_-]{43}$/;
/** Keep invite secrets out of server queries and referrers. Storage is per-tab,
 * temporary handoff only; the server still verifies recipient identity and expiry. */
export function createReferralHandoff(env = {}) {
  const location = env.location ?? globalThis.location;
  const history = env.history ?? globalThis.history;
  let storage;
  try {
    storage = env.storage ?? globalThis.sessionStorage;
  } catch {
    /* Browser may deny storage access entirely. */
  }
  let memory,
    cleared = false;
  function read() {
    if (cleared) return null;
    if (memory) return memory;
    try {
      const value = JSON.parse(storage.getItem(KEY));
      if (
        value &&
        ['invitation', 'stop-invitations'].includes(value.kind) &&
        TOKEN.test(value.token)
      )
        return value;
    } catch {
      /* Browser storage may be disabled. */
    }
    return null;
  }
  function capture() {
    const match = /^#\/(invitation|stop-invitations)\?token=([A-Za-z0-9_-]{43})$/.exec(
      location.hash,
    );
    if (!match) return read();
    cleared = false;
    memory = { kind: match[1], token: match[2] };
    // Remove bearer before any subsequent network request or external navigation.
    history.replaceState(null, '', `${location.pathname}${location.search}#/${match[1]}`);
    try {
      storage.setItem(KEY, JSON.stringify(memory));
    } catch {
      /* Memory fallback remains usable. */
    }
    return memory;
  }
  function clear() {
    memory = null;
    cleared = true;
    try {
      storage.removeItem(KEY);
    } catch {
      /* No persistent value exists in memory fallback. */
    }
  }
  function destination(account) {
    const pending = read();
    if (!pending) return null;
    if (pending.kind === 'stop-invitations') return pending.kind;
    if (
      account?.verificationRequired ||
      account?.onboardingStatus === 'pending' ||
      account?.starterStatus === 'pending'
    )
      return null;
    return 'invitation';
  }
  (env.events ?? globalThis.window)?.addEventListener('hashchange', capture);
  capture();
  return { capture, read, clear, destination };
}
